import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  data: [],
  total: 0,
};

const headerListZmluva = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_LIST_ZMLUVA_HEADER_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_LIST_ZMLUVA_HEADER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.res.Data.Items,
        total: action.res.Data.TotalRecords,
      };

    case actionTypes.GET_LIST_ZMLUVA_HEADER_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default headerListZmluva;
